module.exports = __webpack_public_path__ + "22ba6cf4fef7a5fb0e76ac36d9bb5174.fbx";